import { proxy } from 'valtio'
import { useProxy } from 'valtio/utils'

const store = proxy({ count: 0 ,step:60,num:5,collect:20,endgame:0,startgame:0,del:0,mark:[],touch:false,effectc:false,loaded:false,gamestate:0,boom:false,bonus:false})
export const useStore = () => useProxy(store)
